// Mocked data for Seta Administração clone

export const navItems = [
  { id: 'home', label: 'HOME' },
  { id: 'sobre', label: 'SOBRE NÓS' },
  { id: 'servicos', label: 'SERVIÇOS' },
  { id: 'anos30', label: '30 ANOS' },
  { id: 'news', label: 'SETA NEWS' },
  { id: 'clientes', label: 'CLIENTES' },
  { id: 'contato', label: 'CONTATO' },
  { id: 'equipe', label: 'NÚCLEO DE GESTÃO' },
];

export const heroSlides = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/ca0crdd6_5.png',
    title: 'CONSTRUINDO VALOR E RESPEITANDO HISTÓRIAS.',
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/26jvixot_6.png',
    title: 'TÉCNICA, CONFIANÇA E IMPACTO POSITIVO.',
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/77xur16u_7.png',
    title: '30 ANOS DE EXCELÊNCIA E COMPROMISSO.',
  },
];

export const SETA_LOGO_URL = 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/razdkkby_logo%20topo%20home%20maior.png';
export const BRAZIL_MAP_URL = 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/flawfgsr_MAPA%20MENOR%20COM%20SETA%20%281920%20x%201080%20px%29.png';
export const SELO_30_URL = 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/eiuw00pl_SELO%2030%20ANOS%20-%20ESCRITA%20BRANCA.png';

export const aboutText =
  'A Seta acumula 30 anos de qualificação e experiência no assessoramento e na prestação de serviços em empreendimentos com significativo impacto ambiental e socioeconômico, como no caso de Aproveitamentos Hidrelétricos, Mineração, Prospecção de Gás Natural e Petróleo, Reflorestamentos, Perímetros Irrigados e Assentamentos Rurais, Linhas de Transmissão e Distribuição, dentre outros.';

export const services = [
  {
    id: 'engenharia',
    slug: 'engenharia-de-avaliacoes',
    title: 'ENGENHARIA DE AVALIAÇÕES',
    icon: 'shield-check',
    image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=900&q=80',
    description:
      'Prestação de serviços de avaliações de imóveis baseados nas normas técnicas da ABNT 14.653, visando situar cada empreendimento em seu contexto espacial, ambiental e socioeconômico junto à comunidade.',
    heroImage: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/ca0crdd6_5.png',
    items: [
      'Medição e cadastro de imóveis',
      'Cadastro físico e patrimonial',
      'Pesquisa documental, cartorial e jurídica',
      'Negociação de imóveis em geral',
      'Regularização Fundiária',
      'Laudos de avaliação de imóveis',
      'Laudos de danos',
      'Perícias judiciais e assistência técnica',
    ],
  },
  {
    id: 'socio',
    slug: 'socio-economia',
    title: 'SÓCIO-ECONOMIA',
    icon: 'users-round',
    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=900&q=80',
    description:
      'É fator preponderante na tomada de decisões do empreendedor o desenvolvimento de ações de socioeconomia, compatibilizando prazos, recursos humanos, financeiros e materiais com vistas a otimização dos resultados, sem que ocorra desgaste institucional do empreendedor.',
    heroImage: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/26jvixot_6.png',
    items: [
      'Cadastro e diagnóstico socioeconômico',
      'Reassentamento e reordenação fundiária',
      'Comunicação Social',
      'Anuências e Diligenciamento de Obras',
      'Serviços fundiários',
      'Instituição de servidões (APP\u2019s; LT\u2019s; rodovias, gasodutos, etc.)',
      'Estudos de viabilidade de traçados de LT\u2019s e R5 (EPE)',
    ],
  },
  {
    id: 'consultoria',
    slug: 'consultoria-especializada',
    title: 'CONSULTORIA ESPECIALIZADA',
    icon: 'briefcase',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80',
    description:
      'Exercer consultoria especializada na gestão dos processos fundiários e na auditoria de ativos com transparência e sinergia para o sucesso na implantação dos empreendimentos.',
    heroImage: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/77xur16u_7.png',
    items: [
      'Estudos de Fundiário Pré-Leilão de LT\u2019s (ANEEL)',
      'Estudos e Relatórios R5 (EPE)',
      'Due-Diligence de ativos fundiários',
      'Auditoria em Ativos Fundiários',
      'Estudos de Alternativas Locacionais de LT\u2019s',
      'Aquisições Estratégicas',
      'Relocação de Infraestrutura (Pública, Comunitária e Privada)',
      'Diligenciamento na Construção de LT\u2019s',
      'Monitoramento e Fiscalização de Áreas',
    ],
  },
];

export const anos30Text = [
  'Em 2025, a Seta completa 30 anos de uma jornada baseada em conhecimento, confiança e resultados concretos. Desde sua fundação, a empresa participa de grandes projetos em 24 estados brasileiros e também no Distrito Federal, com atuação destacada em avaliação de imóveis, regularização fundiária, engenharia de dados e soluções técnicas para o setor público e privado.',
  'Ao longo dessas três décadas, acumulou um vasto portfólio de serviços e resultados, participando ativamente de projetos de infraestrutura, energia, agricultura, mineração e planejamento territorial. Esse tempo de mercado não apenas demonstra nossa estabilidade, mas também nossa capacidade de nos reinventar e acompanhar as demandas técnicas e legais de um país em constante transformação.',
  'Acreditamos que uma marca com 30 anos de história deve continuar olhando para o futuro com protagonismo, competência e responsabilidade.',
];

// News moved to backend/data/news.json (served via PHP API).

// Clients organized by original position/importance order.
// The `position` field mirrors the file-name numbering supplied by the client
// and drives grid ordering. New logos simply append at their own position.
export const clients = [
  {
    position: 1,
    name: 'ISA Energia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/zg9307o3_1.png',
  },
  {
    position: 2,
    name: 'CYMI',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/cyqosl3m_2.png',
  },
  {
    position: 3,
    name: 'Neoenergia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/a4bbihnw_3.png',
  },
  {
    position: 4,
    name: 'CPFL Energia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/jpdr5l0j_4.png',
  },
  {
    position: 5,
    name: 'Statkraft',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/kuvyc3xb_5.png',
  },
  {
    position: 6,
    name: 'AngloGold Ashanti',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/xo8snwb8_6.png',
  },
  {
    position: 7,
    name: 'EPE - Empresa de Pesquisa Energética',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/9196owkf_7.png',
  },
  {
    position: 8,
    name: 'Brennand Energia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/otdl7gks_8.png',
  },
  {
    position: 9,
    name: 'Shell',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/azohbixg_9.png',
  },
  {
    position: 10,
    name: 'Amarillo Gold',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/k8mzjb60_10.png',
  },
  {
    position: 11,
    name: 'Heineken',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/o0wi8z1o_11.png',
  },
  {
    position: 12,
    name: 'Omega Energia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/euvsc82n_12.png',
  },
  {
    position: 13,
    name: 'Elera Renováveis',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/sf2yzeuk_13.png',
  },
  {
    position: 14,
    name: 'TSEA Energia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/a3frhaca_14.png',
  },
  {
    position: 15,
    name: 'EDP',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/3gcoesc3_15.png',
  },
  {
    position: 16,
    name: 'GranTierra Energy',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/x5zrde9t_16.png',
  },
  {
    position: 17,
    name: 'Copel',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/2fna2wig_17.png',
  },
  {
    position: 18,
    name: 'Enel',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/du1xwbvs_18.png',
  },
  {
    position: 19,
    name: 'All Energy Engenharia',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/xpqx5me3_19.png',
  },
  {
    position: 20,
    name: 'MinasPCH',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/10nfxo00_20.png',
  },
  {
    position: 21,
    name: 'Consórcio UHE Baguari',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/nmi3kayl_21.png',
  },
  {
    position: 22,
    name: 'WSP',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/jnys023i_22.png',
  },
  {
    position: 23,
    name: 'Cobra',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/s8k93jgq_23.png',
  },
  {
    position: 24,
    name: 'ContourGlobal',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/k6nx2u38_24.png',
  },
  {
    position: 25,
    name: 'Brasil PCH',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_seta-redesign/artifacts/jq32uwz1_25.png',
  },
];

export const team = [
  {
    id: 1,
    name: 'Paulo César Silva Queiroz',
    role: 'Engenheiro Agrônomo',
    photo: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/zn5yxklk_Paulo%20C%C3%A9sar.png',
    linkedin: 'https://www.linkedin.com/in/paulo-queiroz-ab049234/',
  },
  {
    id: 2,
    name: 'Tânia Martins Santana',
    role: 'Assistente Social',
    photo: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/3xqzjgt1_Tania.png',
    linkedin: 'https://www.linkedin.com/in/tania-santana-386191268/',
  },
  {
    id: 3,
    name: 'Marcio Xavier Bartels',
    role: 'Engenheiro Agrônomo',
    photo: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/ckcm8hik_Marcio.png',
    linkedin: 'https://www.linkedin.com/in/marcio-bartels-60921430/',
  },
  {
    id: 4,
    name: 'José Eduardo Trevisan Moraes',
    role: 'Engenheiro Agrônomo',
    photo: 'https://customer-assets.emergentagent.com/job_seta-redesign/artifacts/uxkyz2kw_Jos%C3%A9%20Eduardo.png',
    linkedin: 'https://www.linkedin.com/in/jos%C3%A9-eduardo-trevisan-moraes-72287923/',
  },
];

export const contactInfo = {
  address: 'Paracatu - MG, Brasil',
  instagram: 'setaadmconsultoria',
  instagramUrl: 'https://www.instagram.com/setaadmconsultoria',
};
